<div class="breadcrumb-area">
	<h1>Clientes/Proveedores</h1>
</div>
<div class="card mb-5">
	<div class="card-header">
		<h3>Administración de Clientes/Proveedores <a (click)="editAndSave(null,true)" *ngIf="!creating"><i
					class="a-hover fa fa-plus"></i></a></h3>
	</div>
	<div class="card-body">
		<p class="text-muted">Una cliente se encuentra activa si el icono <i class="fa fa-power-off"></i> se encuentra
			en color <span style="font-weight: 900;color: green;">verde</span>. Activa o desactiva el cliente dando
			click sobre el icono antes mencionado.</p>
		<div class="row">
			<div class="col-sm-4 new-family" *ngIf="creating">
				<h4 id="pin-container">Crea una familia<i (click)="alwaysCreating=!alwaysCreating"
						[class.opacity-20]="!alwaysCreating" class="fa fa-thumbtack"></i></h4>
				<span>Datos de la familia</span>
				<div class="input-group input-group-sm">
					<label for="name-family" class="input-group-text">Nombre</label>
					<input type="text" name="name-family" [(ngModel)]="newVendor.name" id="name-family"
						class="form-control">
				</div>
				<div class="input-group input-group-sm">
					<label for="nit" class="input-group-text">Descripción</label>
					<input type="text" [(ngModel)]="newVendor.nit" name="nit" id="nit" class="form-control">
				</div>
			</div>
			<div [ngClass]="creating?'col-sm-8':'col'">
				<div class="input-group input-group-sm">
					<label for="filterVendors" class="input-group-text">Filtrar</label>
					<input type="text" id="filterVendors" (input)="searching()" [(ngModel)]="searchVendor" placeholder="Ingresa nombre, código o nit de la persona que buscas" name="filterVendors" class="form-control">
				</div>
				<div class="table table-responsive" style="margin-bottom: 0;">
					<table class="table" style="margin-bottom: 0;">
						<thead>
							<tr>
								<th class="ta">
									Estado
								</th>
								<th>
									Nombre
								</th>
								<th>
									NIT
								</th>
								<th>
									Código
								</th>
								<th class="ta">
									Cliente
								</th>
								<th class="ta">
									Proveedor
								</th>
								<th class="ta">
									P. Inventarios
								</th>
								<th class="ta">
									Opción
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let vendor of pagination.filter">
								<tr>
									<td class="ta">
										<i (click)="activeOrInactive(vendor)" class="status-category fa fa-power-off"
											[class.active-category]="vendor.enabled"></i>
									</td>
									<td>
										{{vendor.name}}
									</td>
									<td>
										<span *ngIf="vendor.nit">
											{{vendor.nit}}
										</span>
										<span *ngIf="!vendor.nit" class="opacity-30">
											<i class="fa fa-circle-info"></i> Sin NIT.
										</span>
									</td>
									<td>
										<span *ngIf="vendor.code">
											{{vendor.code}}
										</span>
										<span *ngIf="!vendor.code" class="opacity-30">
											<i class="fa fa-circle-info"></i> Sin código.
										</span>
									</td>
									<td class="ta">
										<i [ngClass]="vendor.client?'fa-check':'fa-xmark opacity-30'" class="fa"></i>
									</td>
									<td class="ta">
										<i [ngClass]="vendor.provider?'fa-check':'fa-xmark opacity-30'" class="fa"></i>
									</td>
									<td class="ta">
										<i [ngClass]="vendor.inventarios?'fa-check':'fa-xmark opacity-30'" class="fa"></i>
									</td>
									<td class="ta">
										<span class="a-hover" (click)="editAndSave(vendor,false)"><i
												class="fa fa-edit"></i></span>
										<span class="a-hover" (click)="createEditVendorBank(vendor)"><i
												class="fa fa-building-columns"></i></span>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
				<app-pagination-custom
				[elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
</div>
<app-modal-vendor *ngIf="creating || editing" [newVendor]="newVendor" [isCreating]="creating" (close)="closeModalProvider()"></app-modal-vendor>
<app-modal-vendor-bank
  *ngIf="modalVendorBank"
  [idVendor]="newVendor.id"
  (close)="closeModalVendorBank($event)">
</app-modal-vendor-bank>